export default __webpack_public_path__ + "static/media/locked-illustration.55f42fbd.png";